module.exports = __webpack_public_path__ + "static/media/viso-product.b9a102e0.jpg";